import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { FormService } from '../../../shared/form.service';
import { CourseService } from '../course.service';
import { CourseModel, CourseRequest, SubjectModel } from '@generativ/much-smarter-models';
import { SubjectService } from '../../../shared/subject.service';
import { AlertService } from '../../../core/alert/alert.service';
import { Observable } from 'rxjs';
import { SortListService } from '../../../shared/sort-list.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, ...MATERIAL_IMPORTS, CapitalizePipe],
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {

  courseId: number;
  course: CourseModel;
  courseForm: FormGroup;
  pageType: string;
  subjects;
  selectedSubjects;
  lessonIds: number[] = [];
  errorMessage: string;
  isSubmitting = false;
  countries = ['us', 'uk'];
  courseStatus: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private courseService: CourseService,
              private subjectService: SubjectService,
              private sortListService: SortListService,
              private alertService: AlertService,
              private location: Location,
              public formService: FormService,) {
    this.courseForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.subjectService.getSubjects().subscribe(
      subjects => {
        this.subjects = subjects;
        this.subjects.map(obj => {
          obj.id = this.subjectService.subjectsEnum[obj.name];
          return obj;
        })
      }
    );
    this.route.data.subscribe((data: any) => {
      this.pageType = data.type;
      if (this.pageType === 'edit') {
        this.route.params.subscribe((params: Params) => {
          this.courseId = +params['courseId'];
          this.courseService.getCourse(this.courseId).subscribe(
            courseModel => {
              this.course = courseModel;
              this.courseForm.patchValue(courseModel);
              this.courseForm.controls.subjects.setValue(courseModel.subject.split(','));
              this.selectedSubjects = courseModel.subject.split(',');
              this.courseStatus = this.course.activated ? 'Deactivate' : 'Activate';
            }
          );
        });
      }
    });
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.courseForm)) {
      let courseObservable: Observable<CourseModel>;
      let message: string;
      this.errorMessage = null;

      if (this.isSubmitting) {
        return;
      }

      if (!this.courseForm.valid) {
        this.errorMessage = 'Errors on form. See fields below.';
        return;
      }

      this.isSubmitting = true;

      if (this.pageType === 'create') {
        const course = new CourseRequest.Create();
        course.parse(this.courseForm.value);
        course.subject = this.courseForm.value.subjects.join(',');
        message = 'Course created';
        courseObservable = this.courseService.createCourse(course);
      } else {
        const course = new CourseRequest.Update();
        course.parse(this.courseForm.value);
        course.lessonIds = this.lessonIds;
        course.subject = this.courseForm.value.subjects.join(',');
        message = 'Course edited successfully';
        courseObservable = this.courseService.updateCourse(this.courseId, course);
      }
      courseObservable.subscribe(
        courseModel => {
          this.alertService.success(message);
          if (this.pageType === 'create') {
            this.router.navigate([`../${courseModel.id}/lessons/create`], {relativeTo: this.route});
          } else {
            this.location.back();
          }
        },
        err => {
          this.isSubmitting = false;
          this.alertService.error(err);
        }
      );
    }
  }

  /**
   * Drag end: Update lesson ids with the new array of order.
   */
  dragEnd() {
    this.lessonIds = this.sortListService.dragEnd(this.course.lessons.map(lesson => lesson.id));
  }

  get buttonName(): string {
    return this.pageType === 'edit' ? 'SAVE' : this.pageType.toUpperCase();
  }

  toggleActive(course) {
    this.submitForm();
    this.courseService.toggleActive(course.id).subscribe(res => {
      alert(`Course ${course.id} has been ${course.activated ? 'deactivated' : 'activated'}`);
      this.courseStatus = res.activated ? 'Deactivate' : 'Activate'
    });
  }

  private  get formOptions(): object {
    return {
      'title': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(100)
        ])
      ],
      'description': [
        null,
        Validators.compose([
          Validators.maxLength(1000)
        ])
      ],
      'country': [
        null,
        Validators.compose([
          Validators.maxLength(1000)
        ])
      ],
      'subjects': [
        [],
        Validators.compose([
          Validators.maxLength(32)
        ])
      ]
    };
  }
}
